import {DateTime} from "luxon";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {IssueStatusDTO} from "../domain/dtos/issue-status.dto";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    target: IssueStatus,
    source: `dto`
})
export class DtoToIssueStatusTransformer extends AbstractDtoToEntityTransformer<IssueStatusDTO, IssueStatus> {

    protected toEntity(dto: IssueStatusDTO): Promise<IssueStatus> {

        const issueStatus = Object.assign(
            new IssueStatus(),
            {
                key: dto.key,
                deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
                isFixed: dto.isFixed ?? false,
                shortcut: dto.shortcut ?? ``,
            }
        );

        return Promise.resolve(issueStatus);
    }

}